import './App.css';

import Registration from './RegistrationPage/Registration';
import RouterApp from './routerApp';


function App() {
  return (
    <div className="App">
      <header className="App-header">
          <RouterApp />
      </header>
    </div>
  );
}

export default App;
